import type { CSSProperties } from 'react';
import { minBreakpoints, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { largeElevation, mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export interface ReviewItemCSS extends CSSProperties {
  '--listWidth': string;
}

export const reviewsContainer = css`
  margin: 0 -${spacing.sm}px;
`;

export const scrollable = css`
  overflow-x: auto;
  scrollbar-width: none;
  padding: 0 ${spacing.sm}px;
`;

export const reviewsList = css`
  display: flex;
  align-items: stretch;
  justify-content: center;
  margin: 0;
  width: var(--listWidth);
  padding: 0 0 ${spacing.xl}px 0;
  column-gap: ${spacing.lg}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: 100%;
    `,
  )}

  > li {
    flex-basis: 100%;

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        flex-basis: 33.33%;
      `,
    )}
  }
`;

export const noReviews = css`
  margin: 0 auto;
  text-align: center;
  width: calc(100% - 32px);
  padding: ${spacing.md}px;
  border-radius: ${spacing.sm}px;
  background-color: var(--neutral-white-base);
  ${largeElevation};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: 33.33%;
    `,
  )}
`;

export const drawerLink = css`
  display: flex;
  ${responsiveText.BODY.SM};
  ${primarySemiBoldFont};
  color: var(--brand-purple-base);
  text-decoration: none;
  border: 1px solid var(--brand-purple-base);
  border-radius: ${spacing.base}px;
  padding: 6px ${spacing.xl}px;
  width: fit-content;
  justify-self: center;
`;

export const placeholderContainer = css`
  display: flex;
  gap: ${spacing.sm}px;
  > div {
    width: 33.33%;
  }
`;
